import { useMachine } from "@xstate/react";
import {
  BaseActionObject,
  Event,
  EventData,
  EventObject,
  InternalMachineOptions,
  MachineConfig,
  ResolveTypegenMeta,
  SCXML,
  ServiceMap,
  SingleOrArray,
  StateMachine,
  TypegenDisabled,
  TypegenMeta,
  createMachine,
} from "xstate";
import { useEffect, useState } from "react";
import { IStateSchema } from "./types/states.type";
import { MiddleWareOptionsModel } from "./middleware/options";
import { CustomEventObject } from "./types/types";

// inspect({
//   url: 'https://stately.ai/viz?inspect',
//   iframe: false,
// })
export function machineConfig<
  Context,
  StateType extends string,
  EventType extends CustomEventObject
>(
  machine: MachineConfig<
    Context,
    IStateSchema<Context, StateType>,
    EventType,
    BaseActionObject,
    ServiceMap,
    TypegenMeta
  >,
  options?: InternalMachineOptions<Context, EventType, BaseActionObject>
) {
  const middleWare = new MiddleWareOptionsModel();
  let middleServicesRes = null;
  if (options) {
    const { services } = options;
    const { middleServices } = middleWare.options<
      Context,
      EventType,
      BaseActionObject
    >(services);
    middleServicesRes = middleServices;
  }

  const { states } = middleWare.stateFinalConfig<
    Context,
    EventType,
    BaseActionObject
  >(machine.states);
  const machine_ = createMachine<
    Context,
    EventType,
    { value: StateType; context: Context },
    any,
    any
  >(
    { ...machine, states },
    {
      ...options,
      services: middleServicesRes,
      actions: options?.actions,
    }
  );
  return machine_;
}

export function useStateMachine<
  IMachineProvider,
  EventType extends EventObject
>(
  machine: StateMachine<
    IMachineProvider,
    IStateSchema<IMachineProvider, string>,
    EventType,
    { value: any; context: IMachineProvider },
    BaseActionObject,
    ServiceMap,
    ResolveTypegenMeta<TypegenDisabled, EventType, BaseActionObject, ServiceMap>
  >
) {
  const [state, send, service] = useMachine(machine, { devTools: true });
  // let _navigate = useNavigate()
  // const location =  useLocation()
  const [query, setQuery] = useState(null);
  const [path, setPath] = useState(null);
  const [updateRoute, setUpdateRoute] = useState(false);

  /**
   *
   * @param event {type: sting or string array}
   * @description call a event to handel actions, event or guard
   * @param payload
   * @description handel data request to save context storage of machine
   * @param config: {updateRoute, search, path}
   * @description:
   * @argument updateRoute - boolean: if it is true, function will handle route of react (default: false or undefine)
   * @augments search - object param: input a param to change or update url of page
   * @argument path - string path: input a path to repalce new url
   */
  function sendEvent(
    event: SCXML.Event<EventType> | SingleOrArray<Event<EventType>>,
    payload?: EventData,
    /**
     * @param{config}
     */
    config?: {
      updateRoute?: boolean;
      search?: any;
      path?: string;
    }
  ) {
    send(event, payload);
    setUpdateRoute(config && config.updateRoute);
    setQuery(config && config.search);
    setPath(config && config.path);
  }

  useEffect(() => {
    const subscription = service.subscribe(
      (item: { transitions: string | any[] }) => {
        // console.log(
        //   '/**************************STATE***************************/'
        // )
        // console.log('/*UNIPORTAL ADMIN LOG @vietunion.com.vn*/')
        // console.log(
        //   '\x1b[36mMachineName:\x1b[0m \x1b[32m%s\x1b[0m',
        //   `${item.machine.id}`
        // )
        // console.log(
        //   '\x1b[36mState current:\x1b[0m \x1b[32m%s\x1b[0m',
        //   `${JSON.stringify(item.value)}`
        // )
        // console.log(item)
        // console.log('\x1b[36mEvent:\x1b[0m \x1b[32m%s\x1b[0m', item.event.type)
        for (let i = 0; i < item.transitions.length; i++) {
          const actions = item.transitions[i].actions.map(
            (item: { type: any }) => item.type
          );
          // console.log(
          //   '\x1b[36mActions:\x1b[0m \x1b[32m%s\x1b[0m',
          //   actions.length ? actions : 'No action'
          // )
          // for (let y = 0; y < item.transitions[i].actions.length; y++) {
          //   const action = item.transitions[i].actions[y]
          //   console.log('\x1b[36mAction:\x1b[0m \x1b[32m%s\x1b[0m', action.type)
          // }
        }
        // console.log(
        //   '  \x1b[42mHistory:\x1b[0m \x1b[32m%s\x1b[0m',
        //   JSON.stringify(item.history ? item?.history?.value : '')
        // )
        // console.log('/**************************END***************************/')
      }
    );
    return subscription.unsubscribe;
  }, [service]);

  // useEffect(() => {
  //   if (navigate) {
  //     if (updateRoute) {
  //       /** logic */
  //       if (!query)
  //         if ((state.context as any).params) {
  //           // câu lệnh update param cho url với data đã có sẳn
  //           navigate((state.context as any).params, false)
  //         }
  //     }
  //     if (updateRoute && query) {
  //       /** logic */
  //       // câu lệnh update param của url
  //       navigate(query, false)
  //     }
  //     if (updateRoute && path) {
  //       /** logic */
  //       // câu lệnh thay đỗi url
  //       navigate(path, true)
  //     }
  //   }
  // }, [query, updateRoute])

  // function navigate(query, hasPath?: boolean) {
  //   if (hasPath == false) {
  //     // hàm này dùng để update param của url => vd: url?[key]=[value] "[key]=[value]" là param thay đỗi
  //     const pathName = location.pathname
  //     const params = generateQueryString(query, 'userName')
  //     const result = `${pathName}${params}`
  //     _navigate(result)
  //   }
  //   if (hasPath == true) {
  //     // hàm  này dùng đễ thay đỗi hẳng url  vd: old url: /page1 -> new url: /page2
  //     const path = query
  //     _navigate(path)
  //   }
  // }
  // function paramsByUrl() {
  //   const params = parseQueryString(location.search)
  //   return params
  // }
  function matches(stateName: string) {
    return state.matches<string>(stateName);
  }
  function can(event: EventType["type"] | EventType) {
    return state.can(event);
  }
  function disabled(event: EventType["type"] | EventType) {
    return !can(event);
  }
  function stop() {
    service.stop();
  }

  function mergeMeta(): any {
    return Object.keys(state.meta).reduce((acc, key) => {
      const value = state.meta[key];
      // Assuming each meta value is an object
      Object.assign(acc, value);
      return acc;
    }, {});
  }
  const stateCustom = {
    ...state,
    id: state.machine.id,
  };
  return {
    ...stateCustom,
    sendEvent,
    matches,
    hasTag: (tag: string) => state.hasTag(tag),
    can,
    disabled,
    stop,
    service,
    mergeMeta,
  };
}
